import { companyLocale, companySymbol } from "@/lib/company";

/** Money in the shop's currency and number format (Settings → My Company). */
export const money = (n, digits = 2) =>
  `${companySymbol()}${Number(n || 0).toLocaleString(companyLocale(), {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;

export const moneyShort = (n) => money(n, 0);
